module.exports = __webpack_public_path__ + "static/media/02-MGM_Casino_Fish_Restaurant.ba7aedfb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/realisations/projet_mgm-casino/02-MGM_Casino_Fish_Restaurant.jpg
// module id = 1187
// module chunks = 37